export const API_URL 				= 	'https://api.weixin.qq.com/sns/oauth2/access_token'

export const API_AI					=	window.location.hostname == 'm.ytgrading.com' ?
                                                'http://ai.ytgrading.com' : 'http://ft1ai.ytgrading.com'

export const API_SHARE_URL 			= 	 API_AI + '/wxtoken/getJsSignature'

export const AND_DOWN_URL			= 'http://app.so.com/detail/index?pname=com.collectiontoolapp.www&id=3960785'
export const IOS_DOWN_URL 			= 'https://itunes.apple.com/cn/app/%E9%87%91%E7%8C%B4%E8%AF%86%E5%AE%9D/id1342117089?mt=8'


// 微信分享服务器
export const WX_SERVER              = 'https://wx.zhaoonline.com'
export const WECHAT_APPID 			= 	window.location.hostname == 'h5.zhaoonline.com' ?
  											'wx57a1cb5eec49bd9f' : 'wxaa40fcdea349de54'





// WEBPACK FOOTER //
// ./src/config/const.js